import { useTranslation } from 'next-i18next';

import { Button, Modal, ModalContent } from '@restworld/ui-ds-base';
import { CoverLetterQuickGuide } from './cover-letter-quick-guide';

function TipsFromOurTeamModal({ isOpen, onClose }: TipsFromOurTeamModalProps) {
  const { t } = useTranslation('onboarding-page');

  return (
    <Modal open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <ModalContent
        showCloseIcon={false}
        hideHeader
        footer={
          <Button fullwidth onClick={onClose}>
            {t('okay_clear')}
          </Button>
        }
      >
        <CoverLetterQuickGuide showCloseButton={false} />
      </ModalContent>
    </Modal>
  );
}

export default TipsFromOurTeamModal;

interface TipsFromOurTeamModalProps {
  isOpen: boolean;
  onClose: () => void;
}
